import { Injectable } from '@angular/core';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { WindowService } from '../../shared/window.service';
import { NUMBER_MAP, NumberTypes } from './support-number-map';
import { TranslationService } from '../../shared/translation.service';

@Injectable()
export class LiveAgentSupportService {

  constructor(
    private oePersonService: OeAppPersonService,
    private windowService: WindowService,
    private translationService: TranslationService
  ) {} 

  startChat() {
    const numberType = this.oePersonService.isB2bStudent() ? NumberTypes.B2B : NumberTypes.B2C;
    const wppNumberUrl = this.translationService.translate(NUMBER_MAP[numberType]);
    this.windowService.openUrl(wppNumberUrl);
  }
}



// WEBPACK FOOTER //
// ./ts/app/header/live-agent-support/live-agent-support.service.ts